import React, { Component } from "react";
import { connect } from "react-redux";

class Step2ShippingFee extends Component {
  render() {
    const { myBagData } = this.props;
    return <div className="step2-shipping-fee">{myBagData.shippingFee}</div>;
  }
}

const mapStateToProps = state => ({
  myBagData: state.myBag.myBagData
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step2ShippingFee);
